import { Monitor01, Moon01, Sun } from "@untitledui/icons";
import { cx } from "@/utils/cx";
import { useThemeStore, type Theme } from "../../stores/themeStore";

/**
 * Přepínač vzhledu (light/dark/system) — UUI-styled segmented control určený do
 * user menu (NavAccountMenu). Nahrazuje legacy `ThemeToggle` (BEM `ui-theme-toggle`).
 */
const OPTIONS: { value: Theme; label: string; Icon: typeof Sun }[] = [
    { value: "light", label: "Světlý", Icon: Sun },
    { value: "dark", label: "Tmavý", Icon: Moon01 },
    { value: "system", label: "Systém", Icon: Monitor01 },
];

export function ThemeMenuControl() {
    const theme = useThemeStore((s) => s.theme);
    const setTheme = useThemeStore((s) => s.setTheme);

    return (
        <div className="px-2 pt-2 pb-1.5">
            <div className="px-1.5 pb-1.5 text-xs font-semibold text-tertiary">Vzhled</div>
            <div role="radiogroup" aria-label="Vzhled" className="flex gap-1 rounded-lg bg-secondary p-1">
                {OPTIONS.map(({ value, label, Icon }) => {
                    const active = theme === value;
                    return (
                        <button
                            key={value}
                            type="button"
                            role="radio"
                            aria-checked={active}
                            onClick={() => setTheme(value)}
                            className={cx(
                                "flex min-w-0 flex-1 cursor-pointer items-center justify-center gap-1 rounded-md px-1.5 py-1.5 text-xs font-medium outline-focus-ring transition duration-100 focus-visible:outline-2 focus-visible:outline-offset-2",
                                active
                                    ? "bg-primary text-secondary shadow-xs ring-1 ring-secondary"
                                    : "text-tertiary hover:text-secondary",
                            )}
                        >
                            <Icon className="size-4 shrink-0" />
                            <span className="truncate">{label}</span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
